import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object({
  memberId: string().required(),
})

export type Request = { memberId: string }
export type SuccessfulResponse = any

export const url = ({ memberId }: Request) => `/v2/members/${memberId}/service-lines`
